<template>
    <div>
        <b-modal
            id="delete-modal"
            size="sm"
            header-bg-variant="dark"
            hide-footer
        >
            <template v-slot:modal-header>
                <h5 class="modal-title text-white">
                <b>Supprimer le rôle</b>
                </h5>
                <i class="fa fa-times text-white" aria-hidden="true" @click="$bvModal.hide('delete-modal')"></i>
            </template> 
            <!-- {{item.patient.name}} -->
            <div class="d-block text-center">
                <p><span class="font-weight-bold"> Nom: </span> {{item.name}}</p>
            </div>

            <div class="d-block float-right" v-if="item">
                <b-button variant="outline-danger" @click="deleteRole(item.id)"> <!-- @click="deleteRole"-->
                    {{ $t('message.delete') }}
                </b-button>
                <b-button variant="secondary" @click="$bvModal.hide('delete-modal')"><!--@click="$bvModal.hide('delete-modal')"-->
                    {{ $t('message.cancel') }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import Swal from 'sweetalert2';
import Vue from 'vue';
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect'
import AppConfig from "../../constants/AppConfig";
import axios from 'axios';

export default {
    name: "DeleteRole",
    props: ['item'],

    computed: {
        ...mapGetters(["errors",'hasAdminRole']),
    },
    
    data() {
        return {
            placements: [
                'topright',
            ],
        }
    },

    methods: {
        getRoles() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getRoles", { args: args });
        },
        deleteRole(role) {
            let args = {
                role: role,
            };
            let successMessage = this.$i18n.t('message.roleDeleted');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };
            this.$bvModal.hide('delete-modal');
            this.$store.dispatch('deleteRole', {args, successMessage, errorMessages})
            .then(() => {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            });
        },
    },
    mounted() {
        
    },
  
    
}
</script>